import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ErrorMessage, Field, Formik } from "formik";
import { TextField } from "formik-mui";
import Mark from "../assets/svg/mark.svg";
import CoverImage from "../components/icons/CoverImage";
import Logo from "../components/icons/Logo";
import { initialSignUpValues, SignupSchema } from "../schemas/AuthSchema";
import { useAuth } from "../context/AuthContext";
import Spinner from "../components/Loader/Spinner";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const { signup, loading } = useAuth();

  const onSelectFile = async (event, setFieldValue) => {
    setFieldValue("profilePicture", event.target.files[0]);
    if (!event.target.files || event.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    setSelectedFile(event.target.files[0]);
  };

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const submitHandler = async (values) => {
    await signup(values);
  };

  return (
    <div className="flex w-full min-h-screen overflow-hidden md:h-screen">
      <CoverImage />
      <div className="flex items-center overflow-auto py-12 justify-between flex-col w-full md:w-[50%] scrollbar-hide">
        <div className="hidden md:block mb-12">
          <Logo />{" "}
        </div>
        <div className="w-full flex flex-col items-center justify-center">
          <div className="md:hidden mb-12 md:mb-0">
            <Logo />{" "}
          </div>
          <h2 className="font-bold text-[20px] md:text-[36px] w-[210px] md:w-[337px] text-[#1A1D4D]">Hello! Sign up to Get Started</h2>
          <Formik onSubmit={submitHandler} initialValues={initialSignUpValues} validationSchema={SignupSchema} enableReinitialize>
            {({ handleSubmit, values, setFieldTouched, setFieldValue }) => (
              <div className="w-full flex flex-col items-center justify-center ">
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"firstName"}
                      label="First Name"
                      onKeyUp={() => setFieldTouched("firstName", true)}
                      value={values.firstName || ""}
                      placeholder="John"
                      component={TextField}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                  </div>
                </div>
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"lastName"}
                      onKeyUp={() => setFieldTouched("lastName", true)}
                      label="Last Name"
                      placeholder="Doe"
                      value={values.lastName || ""}
                      component={TextField}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                  </div>
                </div>{" "}
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"phoneNumber"}
                      label="Phone"
                      onKeyUp={() => setFieldTouched("phoneNumber", true)}
                      placeholder="08123456789"
                      value={values.phoneNumber || ""}
                      component={TextField}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                  </div>
                </div>{" "}
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"email"}
                      onKeyUp={() => setFieldTouched("email", true)}
                      value={values.email || ""}
                      label="Email"
                      placeholder="johndoe@email.com"
                      component={TextField}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                  </div>
                </div>{" "}
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"password"}
                      onKeyDown={(e) => {
                        e.key === "Enter" && handleSubmit();
                      }}
                      label="Password"
                      value={values.password || ""}
                      onKeyUp={() => setFieldTouched("password", true)}
                      placeholder="*********"
                      component={TextField}
                      type={`${showPassword ? "text" : "password"}`}
                      className="border w-full md:w-[337px] border-primary  rounded px-2  focus:outline-none text-[14px] font-semibold "
                    />
                    <i
                      onClick={togglePassword}
                      className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye${showPassword ? "" : "-slash"}`}
                    ></i>
                  </div>
                </div>
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"confirm_password"}
                      onKeyDown={(e) => {
                        e.key === "Enter" && handleSubmit();
                      }}
                      label="Confirm Password"
                      value={values.confirm_password || ""}
                      onKeyUp={() => setFieldTouched("confirm_password", true)}
                      placeholder="*********"
                      component={TextField}
                      type={`${showPassword ? "text" : "password"}`}
                      className="border w-full md:w-[337px] border-primary  rounded px-2  focus:outline-none text-[14px] font-semibold "
                    />
                    <i
                      onClick={togglePassword}
                      className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye${showPassword ? "" : "-slash"}`}
                    ></i>
                  </div>
                </div>
                <div className="pt-6">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"dob"}
                      label="Date of Birth"
                      placeholder="Month/Year"
                      component={TextField}
                      onKeyUp={() => setFieldTouched("dob", true)}
                      value={values.dob || ""}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                  </div>
                </div>{" "}
                <div className="pt-6">
                  <label htmlFor="imageUpload">
                    <div className="flex flex-col text-[#ACACAC]  gap-1 px-6 py-[20px] items-center justify-center border-dashed border-primary border-[1.4px]">
                      {selectedFile?.name ? (
                        <div className="flex gap-4 text-primary">{selectedFile?.name}</div>
                      ) : (
                        <p className="text-[10px] text-jumbleng-gray">
                          <i className="fa-solid fa-circle-plus mr-1 "></i>
                          Upload profile photo
                        </p>
                      )}
                    </div>
                  </label>
                  <input
                    id="imageUpload"
                    type="file"
                    accept="image/*"
                    className="w-0.1 h-0.1 overflow-hidden hidden"
                    onChange={(event) => {
                      if (!event.target.files) return;
                      onSelectFile(event, setFieldValue);
                    }}
                  />
                  <ErrorMessage
                    name={"picture"}
                    render={(msg) => <div className="text-[0.7812rem] text-red-400 text-left font-normal fon text-jumbleng-gray-main">{msg}</div>}
                  />
                </div>
                <p className="text-[12px] md:text-base font-semibold text-[#ACACAC] mt-[40px]">
                  Already have an account?
                  <Link to="/">
                    {" "}
                    <span className="text-primary cursor-pointer pl-2">Login</span>
                  </Link>
                </p>
                <button
                  onClick={handleSubmit}
                  className=" w-[210px] md:w-[337px] h-[50px] bg-primary rounded mt-4 text-white text-base font-semibold"
                >
                  {loading ? <Spinner /> : "Signup"}
                </button>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Register;
